module.exports = __webpack_public_path__ + "static/nordic_5-7618e62e621100d848c290c87b6c555a.jpg";